import React from 'react'
import { Field } from '../../../cms/models/__ModelInfo'
import ProductDataSelect from './components/ProductDataSelect/ProductDataSelect'

const ProductDataRenderer = ({
	field,
	nodes
}: {
	field: Field
	nodes?: string
}) => {
	return <ProductDataSelect field={field} nodes={nodes} />
}
export default ProductDataRenderer
